import React, { forwardRef } from 'react'
import "./print.css"
import myImg from "./estn.png"
import footImg from "./foot.png"
import dayjs from 'dayjs';
const FormFootPrint = forwardRef(function Formtest(props, ref) {
    const { formData } = props;

    const fullDateToShortDate = (date) => {
        if (date) {
            const newDate = dayjs(date).format("DD-MM-YYYY");
            return newDate;
        }
        return "";
    }
  return (
    <>
         <div className="wrapper_page" ref={ref}>
        <div className="page_header">
            <div className="logo">
                <img src={myImg} alt="logo" />
            </div>
            <div className="title">
                <h2>Diabetic Retinopathy Screening Tool</h2>
            </div>
            <div className="facility">
                        <div className="line1"><b>Facility name:</b><span className="spanline">{formData?.facility_name}</span></div>
                        <div className="line1"><b>Facility Type:</b>
                            <label>
                                <input type="checkbox" readOnly   value="Primary"  checked={formData?.facility_type==="primary"} />
                                <span>Primary</span>
                            </label>
                            <label>
                                <input type="checkbox" readOnly  value="Secondary"  checked={formData?.facility_type==="secondary"} />
                                <span>Secondary</span>
                            </label>
                            <label>
                                <input type="checkbox" readOnly   value="Tertiary"  checked={formData?.facility_type==="tertiary"} />
                                <span>Tertiary</span>
                            </label>
                        </div>
                        <div className="line1"><b>Date:</b><span className="spanline">{formData?.form_filling_Date}</span></div>
                    </div>
        </div>
        <div className="page_body">
            <div className="page_leftcol">
            <div className="sect_a">
                            <h6>Section A - Identifying Data</h6>
                            <div className="form">
                                <div className="form_row">
                                    <label>Name</label>&nbsp;&nbsp;
                                    <input type="text" className="input" value={formData?.patient_name} />
                                </div>
                                <div className="form_row">
                                    <label>Age:</label>&nbsp;&nbsp;
                                    <input type="text" className="input small" value={formData?.patient_DOB}/>&nbsp;&nbsp;
                                    <label>Sex:</label>&nbsp;&nbsp;
                                    <input type="text" className="input small" value={formData?.patient_gender} />
                                </div>
                                <div className="form_row">
                                    <label>CMIS Number:</label>&nbsp;&nbsp;
                                    <input type="text" className="input small" value={formData?.patient_cmis_id}/>
                                </div>
                            </div>
                        </div>
                <div className="sect_c">
                    <h6>Section B - Focused history</h6>
                    <table>
                        <tr>
                            <td colSpan="2"><strong>Presenting Complaint:</strong></td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="1" checked={formData?.focused_history_presenting_complaint?.includes("1")} />
                                    <span>Visual disturbances</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.focused_history_presenting_complaint?.includes("1")} />
                                    <span>Pain</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <label>
                                    <input type="checkbox" readOnly value="3" checked={formData?.focused_history_presenting_complaint?.includes("3")} />
                                    <span>Numbness or tingling of hands/feet</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="4" checked={formData?.focused_history_presenting_complaint?.includes("4")} />
                                    <span>Recurrent skin infections</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="5" checked={formData?.focused_history_presenting_complaint?.includes("5")} />
                                    <span>Slow healing Wound/Ulcer</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="6" checked={formData?.focused_history_presenting_complaint?.includes("6")} />
                                    <span>Weight changes</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="7" checked={formData?.focused_history_presenting_complaint?.includes("7")} />
                                    <span>Fatigue/Tiredness</span>
                                </label>
                            </td>
                        </tr>

                    </table>
                    <table>
                        <tr>
                            <td colSpan="3"><strong>Past Medical History/Comorbidity</strong></td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="1" checked={formData?.focused_history_past_medical_history?.includes("1")} />
                                    <span>Diabetes</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.focused_history_past_medical_history?.includes("2")} />
                                    <span>Hypertension</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="3" checked={formData?.focused_history_past_medical_history?.includes("3")} />
                                    <span>Cardiovascular Disease</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="4" checked={formData?.focused_history_past_medical_history?.includes("4")} />
                                    <span>Stroke/CVA/TIA</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="5" checked={formData?.focused_history_past_medical_history?.includes("5")} />
                                    <span>Chronic Kidney disease</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="6" checked={formData?.focused_history_past_medical_history?.includes("6")} />
                                    <span>Obesity</span>
                                </label>
                            </td>

                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="7" checked={formData?.focused_history_past_medical_history?.includes("7")} />
                                    <span>Dyslipidemia</span>
                                </label>
                            </td>
                            <td>
                                <label className="me2">
                                    <input type="checkbox" readOnly value="8" checked={formData?.focused_history_past_medical_history?.includes("8")} />
                                    <span>HIV</span>
                                </label>

                                <label>
                                    <input type="checkbox" readOnly value="9" checked={formData?.focused_history_past_medical_history?.includes("9")} />
                                    <span>TB</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Are you on treatment?
                                <label className="me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.focused_history_on_treatment==="1"} />
                                    <span>Yes</span>
                                </label>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.focused_history_on_treatment==="2"} />
                                    <span>No</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                If yes
                                <label className="me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.focused_history_treatment_type?.includes("1")} />
                                    <span>Traditional</span>
                                </label>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.focused_history_treatment_type?.includes("2")} />
                                    <span>Conventional</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="sect_d">
                    <h6>Section C - Known patients with DM.</h6>
                    <p className="line1"><b>Duration of illness</b>(years): <span>{formData?.known_patients_foot_duration}</span> </p>
                    <div className="line2">
                        <label>
                            <input type="checkbox" readOnly value="1" checked={formData?.known_patients_foot_type?.includes("1")} />
                            <span>Type I</span>
                        </label>
                        <label>
                            <input type="checkbox" readOnly value="2" checked={formData?.known_patients_foot_type?.includes("2")} />
                            <span>Type II</span>
                        </label>
                        <label>
                            <input type="checkbox" readOnly value="3" checked={formData?.known_patients_foot_type?.includes("3")} />
                            <span>Family History of Diabetes</span>
                        </label>
                    </div>
                    <p>
                        Currently on Medication?
                        <label className="me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.known_patients_foot_current_medication==="1"} />
                            <span>Yes</span>
                        </label>
                        <label>
                            <input type="checkbox" readOnly value="2" checked={formData?.known_patients_foot_current_medication==="2"} />
                            <span>No</span>
                        </label>
                    </p>

                  {formData?.known_patients_foot_current_medication==="1" &&  <p>
                                Medication Type
                                <label className="me2">
                                    <input type="checkbox" value="Oral" readOnly checked={formData?.known_patients_foot_medication_oral_injection?.includes("Oral")}/>
                                    <span>Oral</span>
                                </label>
                                <label>
                                    <input type="checkbox" value="Injectables" readOnly checked={formData?.known_patients_foot_medication_oral_injection?.includes("Injectables")}/>
                                    <span>Injectables</span>
                                </label>
                            </p>}


                    <p className="line4">
                                Blood sugar level RBS<span className='bloodtest'>{formData?.known_patients_foot_blood_sugar_level?.RBS}</span>FBS<span className='bloodtest'>{formData?.known_patients_foot_blood_sugar_level?.FBS}</span>HbA1c<span className='bloodtest'>{formData?.known_patients_foot_blood_sugar_level?.HbA1c}</span>
                            </p>
                    <p>Blood sugar levels</p>
                    <p>
                                <label className="me2">
                                    <input type="checkbox" value="1" readOnly checked={formData?.known_patients_foot_blood_sugar_levelsfoot === "1"} />
                                    <span>Well controlled</span>
                                </label>
                                <label className="me2">
                                    <input type="checkbox" value="2" readOnly checked={formData?.known_patients_foot_blood_sugar_levelsfoot === "2"} />
                                    <span>Poorly controlled</span>
                                </label>
                                <label className="me2">
                                    <input type="checkbox" value="3" readOnly checked={formData?.known_patients_foot_blood_sugar_levelsfoot === "3"} />
                                    <span>Not Monitored</span>
                                </label>
                            </p>
                    <table>
                        <tr>
                            <td colSpan="3"><b>Risk Factors</b></td>
                        </tr>
                        <tr>
                            <td>
                                <b>Exercise</b>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="1" checked={formData?.known_patients_foot_risk_factor_excercise_foot==="1"} />
                                    <span>Very active</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.known_patients_foot_risk_factor_excercise_foot==="2"} />
                                    <span>Moderately active</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="3" checked={formData?.known_patients_foot_risk_factor_excercise_foot==="3"} />
                                    <span>Somewhat active</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="4" checked={formData?.known_patients_foot_risk_factor_excercise_foot==="4"} />
                                    <span>Not active</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                        <td colSpan="3">
                                        <p><b>Alcohol use</b> (units per week) <span className="spanline">{formData?.known_patients_foot_alochol_use_foot}</span></p>
                                    </td>
                        </tr>
                        <tr>
                                    <td>
                                        <b>Diet</b>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1" readOnly checked={formData?.known_patients_foot_diet_foot==="1"}/>
                                            <span>Healthy</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="2" readOnly checked={formData?.known_patients_foot_diet_foot==="2"}/>
                                            <span>Unhealthy</span>
                                        </label>
                                    </td>
                                </tr>
                        <tr>
                            <td>
                                <b>Smoker</b>
                            </td>
                            <td>
                    <label>
                      <input type="checkbox" readOnly value="Yes" checked={formData?.known_patients_foot_smoker_foot==="Yes"}/>
                      <span>Yes</span>
                    </label>
                  </td>
                  <td>
                    <label>
                      <input type="checkbox" readOnly value="No" checked={formData?.known_patients_foot_smoker_foot==="No"}/>
                      <span>No</span>
                    </label>
                  </td>
                        </tr>
                    </table>
                </div>
                <div className="sect_dx">
                    <h6>Section D - Assessment of footwear most often worn</h6>
                    <table>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="1" checked={formData?.footwear_often_worn?.includes("1")} />
                                    <span>Closed</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.footwear_often_worn?.includes("2")} />
                                    <span>Open</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="3" checked={formData?.footwear_often_worn?.includes("3")} />
                                    <span>Correct size</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="4" checked={formData?.footwear_often_worn?.includes("4")} />
                                    <span>Too large</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="5" checked={formData?.footwear_often_worn?.includes("5")} />
                                    <span>Too Small</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="6" checked={formData?.footwear_often_worn?.includes("6")} />
                                    <span>Soft upper</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="7" checked={formData?.footwear_often_worn?.includes("7")} />
                                    <span>Rigid upper</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="8" checked={formData?.footwear_often_worn?.includes("8")} />
                                    <span>Rigid sole</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="9" checked={formData?.footwear_often_worn?.includes("9")} />
                                    <span>Flexible sole</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="3">
                                <label>
                                    <input type="checkbox" readOnly value="10" checked={formData?.footwear_often_worn?.includes("10")} />
                                    <span>Shallow toe box</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td colSpan="2">
                                <b>Frequency of wearing footwear:</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="1" checked={formData?.frequency_footwear==="1"} />
                                    <span>Most of the day</span>
                                </label>
                            </td>
                            <td>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.frequency_footwear==="2"} />
                                    <span>Occasionally on outings</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <label>
                                    <input type="checkbox" readOnly value="3" checked={formData?.frequency_footwear==="3"} />
                                    <span>Frequently go without shoes</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="sect_ex">
                    <h6>Section E - General assessment of the foot</h6>
                    <div>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.foot_assesment?.includes("1")} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.foot_assesment?.includes("2")} />
                            <span>Corns</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="3" checked={formData?.foot_assesment?.includes("3")} />
                            <span>Calluses</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="4" checked={formData?.foot_assesment?.includes("4")} />
                            <span>Bunions</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="5" checked={formData?.foot_assesment?.includes("5")} />
                            <span>Ingrown Toenails</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="6" checked={formData?.foot_assesment?.includes("6")} />
                            <span>Claw Toes</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="7" checked={formData?.foot_assesment?.includes("7")} />
                            <span>Flat Foot</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="8" checked={formData?.foot_assesment?.includes("8")} />
                            <span>Wounds</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="9" checked={formData?.foot_assesment?.includes("9")} />
                            <span>Ulceration</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="10" checked={formData?.foot_assesment?.includes("10")} />
                            <span>High Arched Foot</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="11" checked={formData?.foot_assesment?.includes("11")} />
                            <span>Swelling</span>
                        </label>
                    </div>
                    <table width="100%">
                        <tr>
                            <td rowSpan="2"><b>Nail Infection</b></td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.foot_assesment_nail_infection?.includes("1")} />
                                    <span>Fungal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.foot_assesment_nail_infection?.includes("2")} />
                                    <span>Bacterial</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="3" checked={formData?.foot_assesment_nail_infection?.includes("3")} />
                                    <span>Unknown</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="4" checked={formData?.foot_assesment_nail_infection?.includes("4")} />
                                    <span>Oedema</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                    <div>
                        <b className="me2">Orthopedic range of motion</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.foot_assesment_orthopedic_motion==="1"} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.foot_assesment_orthopedic_motion==="2"} />
                            <span>Abnormal</span>
                        </label>
                    </div>

                </div>
                <div className="sect_fx">
                    <h6>Section F - Assessment of the skin of the lower leg and foot</h6>
                    <div>
                        <b>Temperature</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.skin_assesment_temperature==="1"} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.skin_assesment_temperature==="2"} />
                            <span>Warm</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="3" checked={formData?.skin_assesment_temperature==="3"} />
                            <span>Cool</span>
                        </label>
                    </div>
                    <div>
                        <b>Colour</b>
                        <label className="textnowrap me1">
                            <input type="checkbox" readOnly value="1" checked={formData?.skin_assesment_color==="1"} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me1">
                            <input type="checkbox" readOnly value="2" checked={formData?.skin_assesment_color==="2"} />
                            <span>Pale</span>
                        </label>
                        <label className="textnowrap me1">
                            <input type="checkbox" readOnly value="3" checked={formData?.skin_assesment_color==="3"} />
                            <span>Reddish</span>
                        </label>
                        <label className="textnowrap me1">
                            <input type="checkbox" readOnly value="4" checked={formData?.skin_assesment_color==="4"} />
                            <span>Cyanosis</span>
                        </label>
                        <label className="textnowrap me1">
                            <input type="checkbox" readOnly value="5" checked={formData?.skin_assesment_color==="5"} />
                            <span>Mottled</span>
                        </label>
                    </div>
                    <div>
                        <b>Skin infection</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.skin_assesment_infection?.includes("1")} />
                            <span>Fungal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.skin_assesment_infection?.includes("2")} />
                            <span>Bacterial</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="3" checked={formData?.skin_assesment_infection?.includes("3")} />
                            <span>Unknown</span>
                        </label>
                    </div>
                    <div>
                        <b>Skin texture</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.skin_assesment_texture==="1"} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.skin_assesment_texture==="2"} />
                            <span>Thinner</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="3" checked={formData?.skin_assesment_texture==="3"} />
                            <span>Thickened</span>
                        </label>
                    </div>
                    <div>
                        <b>Skin moisture</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.skin_assesment_moisture==="1"} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.skin_assesment_moisture==="2"} />
                            <span>Sweaty</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="3" checked={formData?.skin_assesment_moisture==="3"} />
                            <span>Dry</span>
                        </label>
                    </div>
                    <div>
                        <b>Temp gradient</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.skin_assesment_gradient==="1"} />
                            <span>Normal</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.skin_assesment_gradient==="2"} />
                            <span>Abnormal</span>
                        </label>
                    </div>

                </div>
          

            </div>
            <div className="page_rightcol">
                <div className="sect_gx">
                    <h6>Section G - Assessment of Vascular Supply</h6>
                    <table className="spctable1" cellPadding="2">
                        <tr>
                            <td rowSpan="4" className="brd_rght">
                                <div className="benddiv">
                                    <span>Pulse Left leg</span>
                                </div>
                            </td>
                            <td>Dorsalis Pedis Pulse</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPlulses_left_leg_dorsalis_pedis==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPlulses_left_leg_dorsalis_pedis==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Anterior Tibial</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPlulses_left_leg_anterior_tibial==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPlulses_left_leg_anterior_tibial==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Posterior Tibial</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPlulses_left_leg_posterior_tibial==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPlulses_left_leg_posterior_tibial==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Popliteal</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPlulses_left_leg_popliteal==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPlulses_left_leg_popliteal==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td rowSpan="4" className="brd_rght brd_top">
                                <div className="benddiv">
                                    <span>Pulse Right leg</span>
                                </div>
                            </td>
                            <td className="brd_top">Dorsalis Pedis Pulse</td>
                            <td className="brd_top">
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPulses_right_leg_dorsalis_pedis==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td className="brd_top">
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPulses_right_leg_dorsalis_pedis==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Anterior Tibial</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPulses_right_leg_anterior_tibial==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPulses_right_leg_anterior_tibial==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Posterior Tibial</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPulses_right_leg_posterior_tibial==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPulses_right_leg_posterior_tibial==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Popliteal</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.vPulses_right_leg_popliteal==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.vPulses_right_leg_popliteal==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                    <div>
                        <b>Doppler</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.vDoppler==="1"} />
                            <span>Done</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.vDoppler==="2"} />
                            <span>Not applicable</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="3" checked={formData?.vDoppler==="3"} />
                            <span>Referred</span>
                        </label>
                    </div>
                    <table className="spctable1" cellPadding="2">
                        <tr>
                            <td rowSpan="4" className="brd_rght">
                                <div className="benddiv">
                                    <span>Left leg</span>
                                </div>
                            </td>
                            <td>Dorsalis Pedis Pulse</td>
                        </tr>
                        <tr>
                            <td>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="1" checked={formData?.dorsalis_pedis_left_leg==="1"} />
                                    <span>Mono Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="2" checked={formData?.dorsalis_pedis_left_leg==="2"} />
                                    <span>Bi Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="3" checked={formData?.dorsalis_pedis_left_leg==="3"} />
                                    <span>Tri Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="4" checked={formData?.dorsalis_pedis_left_leg==="4"} />
                                    <span>Inaudible</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Posterior Tibial</td>
                        </tr>
                        <tr>
                            <td>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="1" checked={formData?.posterior_tibial_left_leg==="1"} />
                                    <span>Mono Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="2" checked={formData?.posterior_tibial_left_leg==="2"} />
                                    <span>Bi Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="3" checked={formData?.posterior_tibial_left_leg==="3"} />
                                    <span>Tri Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="4" checked={formData?.posterior_tibial_left_leg==="4"} />
                                    <span>Inaudible</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td rowSpan="4" className="brd_rght brd_top">
                                <div className="benddiv">
                                    <span>Right leg</span>
                                </div>
                            </td>
                            <td className="brd_top">Dorsalis Pedis Pulse</td>
                        </tr>
                        <tr>
                            <td>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="1" checked={formData?.dorsalis_pedis_right_leg==="1"} />
                                    <span>Mono Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="2" checked={formData?.dorsalis_pedis_right_leg==="2"} />
                                    <span>Bi Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="3" checked={formData?.dorsalis_pedis_right_leg==="3"} />
                                    <span>Tri Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="4" checked={formData?.dorsalis_pedis_right_leg==="4"} />
                                    <span>Inaudible</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Posterior Tibial</td>
                        </tr>
                        <tr>
                            <td>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="1" checked={formData?.posterior_tibial_right_leg==="1"} />
                                    <span>Mono Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="2" checked={formData?.posterior_tibial_right_leg==="2"} />
                                    <span>Bi Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="3" checked={formData?.posterior_tibial_right_leg==="3"} />
                                    <span>Tri Phasic</span>
                                </label>
                                <label className="textnowrap me1">
                                    <input type="checkbox" readOnly value="4" checked={formData?.posterior_tibial_right_leg==="4"} />
                                    <span>Inaudible</span>
                                </label>
                            </td>
                        </tr>

                    </table>
                    <div>
                        <b>APBI</b>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="1" checked={formData?.vABPI?.includes("1")} />
                            <span>Left Leg</span>
                        </label>
                        <label className="textnowrap me2">
                            <input type="checkbox" readOnly value="2" checked={formData?.vABPI?.includes("2")} />
                            <span>Right Leg</span>
                        </label>
                    </div>
                </div>
                <div className="sect_hx">
                    <h6>Section H - Assessment of neurological status</h6>
                    <table className="spctable1" cellPadding="2">
                        <tr>
                            <td rowSpan="4" className="brd_rght">
                                <div className="benddiv">
                                    <span>Left </span>
                                </div>
                            </td>
                            <td>Pain sensation</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_left_pain_sensation==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_left_pain_sensation==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Light Touch</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_left_light_touch==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_left_light_touch==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Temperature Sensation</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_left_temperature_sensation==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_right_temperature_sensation==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Vibration Sensation</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_left_vibration_sensation==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_left_vibration_sensation==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td rowSpan="4" className="brd_rght brd_top">
                                <div className="benddiv">
                                    <span>Right</span>
                                </div>
                            </td>
                            <td className="brd_top">Pain sensation</td>
                            <td className="brd_top">
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_right_pain_sensation==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td className="brd_top">
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_right_pain_sensation==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Light Touch</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_right_light_touch==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_right_light_touch==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Temperature Sensation</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_right_temperature==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_right_temperature==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td>Vibration Sensation</td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.neurological_right_vibration_sensation==="1"} />
                                    <span>Normal</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.neurological_right_vibration_sensation==="2"} />
                                    <span>Abnormal</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                    <div className="foot_img">
                    <img src={footImg} alt="foot" className="foot_img" />
                    <input type="checkbox" className="footchk lchk1" checked={formData?.foot_sensation_diag_left?.includes("1")}   readOnly/>
                        <input type="checkbox" className="footchk lchk2" checked={formData?.foot_sensation_diag_left?.includes("2")}   readOnly/>
                        <input type="checkbox" className="footchk lchk3" checked={formData?.foot_sensation_diag_left?.includes("3")}   readOnly/>
                        <input type="checkbox" className="footchk lchk4" checked={formData?.foot_sensation_diag_left?.includes("4")}   readOnly/>
                        <input type="checkbox" className="footchk lchk5" checked={formData?.foot_sensation_diag_left?.includes("5")}   readOnly/>
                        <input type="checkbox" className="footchk lchk6" checked={formData?.foot_sensation_diag_left?.includes("6")}   readOnly/>
                        <input type="checkbox" className="footchk lchk7" checked={formData?.foot_sensation_diag_left?.includes("7")}  readOnly />
                        <input type="checkbox" className="footchk lchk8" checked={formData?.foot_sensation_diag_left?.includes("8")}   readOnly/>
                        <input type="checkbox" className="footchk lchk9" checked={formData?.foot_sensation_diag_left?.includes("9")}   readOnly/>
                        <input type="checkbox" className="footchk lchk10" checked={formData?.foot_sensation_diag_left?.includes("10")}   readOnly/>

                        <input type="checkbox" className="footchk rchk1" checked={formData?.foot_sensation_diag_right?.includes("1")}   readOnly/>
                        <input type="checkbox" className="footchk rchk2" checked={formData?.foot_sensation_diag_right?.includes("2")}   readOnly/>
                        <input type="checkbox" className="footchk rchk3" checked={formData?.foot_sensation_diag_right?.includes("3")}  readOnly />
                        <input type="checkbox" className="footchk rchk4" checked={formData?.foot_sensation_diag_right?.includes("4")}   readOnly/>
                        <input type="checkbox" className="footchk rchk5" checked={formData?.foot_sensation_diag_right?.includes("5")}   readOnly/>
                        <input type="checkbox" className="footchk rchk6" checked={formData?.foot_sensation_diag_right?.includes("6")}   readOnly/>
                        <input type="checkbox" className="footchk rchk7" checked={formData?.foot_sensation_diag_right?.includes("7")}   readOnly/>
                        <input type="checkbox" className="footchk rchk8" checked={formData?.foot_sensation_diag_right?.includes("8")}   readOnly/>
                        <input type="checkbox" className="footchk rchk9" checked={formData?.foot_sensation_diag_right?.includes("9")}   readOnly/>
                        <input type="checkbox" className="footchk rchk10" checked={formData?.foot_sensation_diag_right?.includes("10")}   readOnly/>
                    </div>
                    <p>10g Monofilament - <b>Mark with An 'X' area where sensation is lost or diminished</b></p>
                    <p className="line1">Score R [<span className="spanline">{formData?.foot_sensation_diag_right_select}</span>/10] L [<span className="spanline">{formData?.foot_sensation_diag_left_select}</span>/10]
                    </p>
                </div>
                <div className="sect_ix">
                    <h6>Section I - History of foot amputation</h6>
                    <table width="100%">
                        <tr>
                            <td><b>Left leg</b></td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.amputation_left?.includes("1")} />
                                    <span>Digits</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.amputation_left?.includes("2")} />
                                    <span>Foot </span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="3" checked={formData?.amputation_left?.includes("3")} />
                                    <span>BKA </span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="4" checked={formData?.amputation_left?.includes("4")} />
                                    <span>AKA</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td><b>Right leg</b></td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="1" checked={formData?.amputation_right?.includes("1")} />
                                    <span>Digits</span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="2" checked={formData?.amputation_right?.includes("2")} />
                                    <span>Foot </span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="3" checked={formData?.amputation_right?.includes("3")} />
                                    <span>BKA </span>
                                </label>
                            </td>
                            <td>
                                <label className="textnowrap me2">
                                    <input type="checkbox" readOnly value="4" checked={formData?.amputation_right?.includes("4")} />
                                    <span>AKA</span>
                                </label>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="sect_h">
                    <h6>Section J - Summary Risk Rating for Diabetic Foot Complications</h6>
                    <table className="table" cellPadding="2">
                        <tr>
                            <td><input type="checkbox" readOnly value="0" checked={formData?.form_risk_rating==="0"} /></td>
                            <td className="bggreen tdlspc">0 = Low Risk</td>
                        </tr>
                        <tr>
                            <td><input type="checkbox" readOnly value="1" checked={formData?.form_risk_rating==="1"} /></td>
                            <td className="bgorange tdlspc">1 = Moderate Risk</td>
                        </tr>
                        <tr>
                            <td><input type="checkbox" readOnly value="2" checked={formData?.form_risk_rating==="2"} /></td>
                            <td className="bgmagenta tdlspc">2 = High Risk</td>
                        </tr>
                        <tr>
                            <td><input type="checkbox" readOnly value="3" checked={formData?.form_risk_rating==="3"} /></td>
                            <td className="bgred tdlspc">3 = Active Diabetic Foot Disease</td>
                        </tr>
                    </table>
                </div>



            </div>
        </div>
        <div className="page_footer">
            <table width="100%" cellSpacing="10">
                {/* <tr>
                    <td>
                        <p className="line1"><b>Clinician Name</b><span className="spanline">{formData?.hospital_Name}</span></p>
                    </td>
                    <td>
                        <p className="line1"><b>Clinician Signature</b><span className="spanline"></span></p>
                    </td>
                </tr> */}
                <tr>
                    {/* <td>
                        <span className="me2">Referral</span>
                        <label className="me2">
                            <input type="checkbox" readOnly value="1"  />
                            <span>Yes</span>
                        </label>
                        <label>
                            <input type="checkbox" readOnly value="2"  />
                            <span>No</span>
                        </label>
                    </td> */}
                    <td>
                        <p className="line1"><b>Referral site name</b><span className="spanline">{formData?.hospital_Name}</span></p>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    </>
  );
});

export default FormFootPrint